export function getRailsEnv() {
  // NOTE: This will only work while we are using Webpack. If we ever migrate
  // off of Webpack, we will need to use another strategy
  return process.env.RAILS_ENV
}
